import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

// S'assurer que le DOM est chargé avant de rendre l'application
document.addEventListener("DOMContentLoaded", () => {
  const rootElement = document.getElementById("root");

  if (rootElement) {
    ReactDOM.createRoot(rootElement).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } else {
    console.error("Impossible de trouver l'élément avec l'ID 'root'");
  }
});
